export const FEATURES_CONSTANTS = {
  title: "Key Features of Shared Compute (Legacy Intel)",
  list: [
    {
      label: "Intel Xeon-Based Virtualization",
      text: "Provision virtual machines on stable, multi-core legacy Intel Xeon hardware—ideal for low-to-moderate compute workloads.",
    },
    {
      label: "Fixed vCPU & RAM Quotas",
      text: "Select from predefined instance types with balanced resource allocation for predictable performance.",
    },
    {
      label: "Snapshot Support",
      text: "Perform manual or scheduled VM snapshots to enable rollback, cloning, or pre-maintenance recovery points.",
    },
    {
      label: "Secure VM Isolation",
      text: "Hypervisor-based logical separation ensures tenant data and workloads remain isolated—even on shared infrastructure.",
    },
    {
      label: "NAT-Enabled Outbound Internet",
      text: "Outbound internet access via shared NAT gateways—safe, simple, and ideal for patching or external API communication.",
    },
    {
      label: "Block Storage Integration",
      text: "Attach scalable block storage volumes with support for backups, snapshots, and performance monitoring.",
    },
    {
      label: "Private VLAN & Networking Support",
      text: "Use custom VLANs or private subnets to interconnect VMs and internal services without exposing them to the public internet.",
    },
    {
      label: "Built-In Monitoring Dashboard",
      text: "Track CPU, memory, disk, and network usage in real-time through the OneMind management portal.",
    },
  ],
};
